import "whatwg-fetch";
import './libs/template-polyfill';
import { View } from '@appstractdk/as-core';
import Header from './components/header';
import Accordion from './components/accordion';
import Dropdown from './components/dropdown';

class App extends View {
	constructor(el) {
		super(el);
		if (!document.querySelector(".dark-font")) {
			document.querySelector(".header").classList.add("white-font");
		}

		this.data = {};
		this.data["dropdowns"] = {};

		const components = [];
		const componentsWithHandler = [Header];
		this.load(components);
		this.loadWithHandler(componentsWithHandler);
		Accordion.init();
	}

	load(components) {
		if (components.length) {
			components.forEach(c => c.init && c.init());
		}
	}
	loadWithHandler(componentsWithHandler) {
		if (componentsWithHandler.length) {
			componentsWithHandler.forEach(c => c.init && c.init(this));
		}
	}

	ifDropdownAlreadyExistsInHandlerRenameIt(dropdowns, name) {
		if (Object.prototype.hasOwnProperty.call(dropdowns, name)) {
			name = name + "B";
			return this.ifDropdownAlreadyExistsInHandlerRenameIt(dropdowns, name);
		}

		return name;
	}


	initDropdown(dropdown, library, keepOpenOnSelectOption, hasSearch) {
		if (!dropdown) { return }

		const selectField = dropdown.querySelector(".js-select-field");
		let optionsName = selectField.getAttribute("data-options-name");

		let fields = [];
		let dropdowns = this.data["dropdowns"];

		const name = this.ifDropdownAlreadyExistsInHandlerRenameIt(dropdowns, optionsName);

		dropdowns[name] = {};
		dropdowns[name]["markup"] = [];

		if (selectField.options.length < 1) {
			return;
		}

		for (let i = 0; i < selectField.options.length; i++) {
			const selectFieldOption = selectField.options[i];

			if (selectFieldOption.disabled) { continue; }
			if (selectFieldOption.selected) {
				dropdowns[name]["selected"] = selectFieldOption.getAttribute("data-id");
			}

			let obj = {};
			obj.Value = selectFieldOption.value;
			obj.Text = selectFieldOption.innerHTML;
			obj.Name = selectField.getAttribute("data-options-name");

			// Add all datatypes to our dropdown object
			for (let i in selectFieldOption.dataset) {
				obj[i] = selectFieldOption.dataset[i];
			}

			fields.push(obj);
		}

		const init = new Dropdown(dropdown, fields, this, library, keepOpenOnSelectOption, hasSearch);

		dropdowns[name]["class"] = init;
	}

}

export default App;
